module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/patients/followup-exam.component.css
// module id = ./src/app/views/patients/followup-exam.component.css
// module chunks = main